var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AwsUi } from '../../../core/runtime/src';
import LegacyClassBuilder from '../../../core/utils/src/class-builders/legacy';
import { Icon } from '../../icon/src';
import { Option } from '../../dropdown/src';
export default AwsUi.__addComponent('awsui-select-trigger', {
    releaseStatus: 'internal',
    properties: {
        // Hint text when no value has been selected.
        placeholder: {
            type: 'string'
        },
        // Text to be displayed.
        selectedOption: {
            type: 'object',
            objectType: 'Select.Option'
        },
        // Whether the trigger should be disabled. In angular use
        // `data-disabled` instead.
        disabled: {
            type: 'boolean'
        },
        // Render the control in invalid state.
        invalid: {
            type: 'boolean',
            nullable: true
        },
        variant: {
            type: 'string',
            valid: ['label', 'option'],
            defaultValue: 'label'
        },
        open: {
            type: 'boolean',
            defaultValue: false
        },
        // Id for the dropdown options.
        dropdownControlId: {
            type: 'string'
        },
        // Id for this trigger. It is announced to receive labels from FormField
        controlId: {
            type: 'string',
            announceValue: true
        },
        // Adds aria-label on the trigger.
        ariaLabel: {
            type: 'string'
        },
        // Adds aria-labelledby on the trigger. Use this only with form fields that
        // contain multiple controls under the same label.
        // 1. Define a custom id inside the label
        // 2. Refer to that label from every single control under that label using this property
        ariaLabelledby: {
            type: 'string'
        },
        // Adds aria-describedby on the trigger. Use this only with form fields that
        // contain multiple controls under the same label.
        // 1. Define custom ids inside the description, hint and error text
        // 2. Refer to these from every single control under that label using this property
        // 3. Refer to any other hint/description text that you provide
        ariaDescribedby: {
            type: 'string',
            nullable: true
        },
        // A default suggested aria-describedby value that can be pushed down from a FormField
        __suggestedAriaDescribedby: {
            type: 'string'
        }
    },
    functions: {
        // Focuses the trigger.
        focus: function () {
            this.node.querySelector('.awsui-select-trigger').focus();
        }
    },
    events: {
        __toggle: {
            bubbles: true,
            cancelable: false
        },
        __triggerBlur: {
            bubbles: true,
            cancelable: false
        },
        __triggerFocus: {
            bubbles: true,
            cancelable: false
        }
    },
    render: function (m, h) {
        var _this = this;
        var cb = new LegacyClassBuilder(this);
        cb.addClass('awsui-select-trigger')
            .addClass('awsui-dropdown-trigger')
            .addComponentClass('disabled', this.disabled)
            .addComponentClass('no-option', !this.selectedOption)
            .addPropertyValueClass('variant');
        if (typeof this.invalid === 'boolean') {
            cb.addComponentClass('valid', !this.invalid).addComponentClass('invalid', this.invalid);
        }
        var attributes = {
            className: cb.toClassName(),
            id: this.controlId,
            onfocus: function () { return _this.__fireEvent('__triggerFocus'); },
            onblur: function () { return _this.__fireEvent('__triggerBlur'); },
            'override-focus': true,
            'aria-expanded': "" + this.open,
            'aria-labelledby': (this.ariaLabelledby || '') + " " + (this.ariaLabel ? this.controlId + "-label" : '') + " " + this.controlId + "-textbox",
            // Do not specify placeholder when we have an option, otherwise screenreaders
            // will read the placeholder text regardlessly.
            placeholder: this.selectedOption ? false : this.placeholder,
            disabled: this.disabled,
            role: 'button',
            'aria-haspopup': 'listbox'
        };
        if (!this.disabled) {
            attributes.tabindex = 0;
            attributes.onmousedown = function (e) {
                // We need to prevent the default behavior (which is focusing the trigger),
                // because IE11 is not always able to focus correctly. Instead, we need to manage the focus ourselves,
                // see the interaction handler.
                e.preventDefault();
                _this.__fireEvent('__toggle');
            };
        }
        var ariaDescribedby = this.ariaDescribedby || this.__suggestedAriaDescribedby;
        if (ariaDescribedby) {
            attributes['aria-describedby'] = ariaDescribedby;
        }
        if (this.invalid) {
            attributes['aria-invalid'] = 'true';
        }
        var value = function () {
            return _this.variant === 'option' ? (AwsUi.__createElement(Option, { disabled: _this.disabled, option: _this.selectedOption, selectable: false })) : (AwsUi.__createElement("span", { className: "awsui-select-trigger-label" }, _this.selectedOption.label));
        };
        var trigger = function () {
            if (_this.selectedOption) {
                return value();
            }
            if (_this.placeholder) {
                return AwsUi.__createElement("span", { className: "awsui-select-trigger-placeholder" }, _this.placeholder);
            }
            return null;
        };
        var label = function () {
            return _this.ariaLabel ? (AwsUi.__createElement("span", { id: _this.controlId + "-label", className: "awsui-util-hide" }, _this.ariaLabel)) : ('');
        };
        return (AwsUi.__createElement("div", __assign({}, attributes),
            label(),
            AwsUi.__createElement("div", { className: "awsui-select-trigger-wrapper" },
                AwsUi.__createElement("span", { className: "awsui-select-trigger-textbox", id: this.controlId + "-textbox" }, trigger()),
                AwsUi.__createElement(Icon, { className: "awsui-select-trigger-icon", name: "caret-down-filled" }))));
    }
});
//# sourceMappingURL=trigger.js.map